import { useEffect, useRef } from "react";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import MyRoutes from "./Routes/routes";
import store from "./store";
import { authCheck } from "./store/actions/auth";
import { useZendeskChat } from "hooks/useZendeskChat";

import "react-toastify/dist/ReactToastify.css";
import 'Assets/css/timepicker.css';
import "react-phone-number-input/style.css";
import "./App.css";

store.dispatch(authCheck());

function App() {
  const zendeskRef = useZendeskChat();

  return (
    <>
      <Provider store={store}>
        <ToastContainer />
        <MyRoutes />
        <div id="nta-zendesk-widget" ref={zendeskRef}></div>
      </Provider>
    </>
  );
}

export default App;
